<template>
  <b-row>
    <b-col sm="12">
      <my-card title="Daftar Paket Item">
        <template slot="button">
          <button-add v-if="cP(66)" :to="{name: 'itempackages-add'}" variant="primary"></button-add>
        </template>
        <template slot="body">
          <data-tables ref="datatables" endpoint="v1/item_packages" :fields="fields">
            <template v-slot:4="{item}">
              <b-badge variant="light-primary" v-if="item[4]==1">Ya</b-badge>
              <b-badge variant="light-warning" v-else>Tidak</b-badge>
            </template>
            <template v-slot:6="{item}">
              <div class="float-none">
                <!-- <button-link size="sm" :to="{name:'itempackages-show',params:{id: item[4]}}" feather-icon="FolderIcon"></button-link> -->
                <button-link v-if="cP(67)" size="sm" :to="{name:'itempackages-edit',params:{id: item[6]}}" feather-icon="EditIcon"></button-link>
                <button-delete v-if="cP(68)" @ondelete="deleteRow" :id="item[6]" :name="`${item[0]} (${item[1]})`"></button-delete>
              </div>
            </template>
          </data-tables>
        </template>
      </my-card>
    </b-col>
  </b-row>
</template>

<script>
import ButtonAdd from '@/my-components/ButtonAdd.vue'
import DataTables from '@/my-components/DataTables.vue'
import ButtonDelete from '@/my-components/ButtonDelete.vue'
import ButtonLink from '@/my-components/ButtonLink.vue'
import {BBadge} from 'bootstrap-vue'

export default {
  components:{
    ButtonAdd,
    DataTables,
    ButtonDelete,
    ButtonLink,
    BBadge
  },
  data() {
    return {
      fields: {
        0:{sortable: true, searchable: true, label:'Kode'},
        1:{sortable: true, searchable: true, label:'Nama'},
        2:{sortable: true, searchable: true, label:'Alias'},
        3:{sortable: true, searchable: true, label:'Nama Kategori'},
        4:{sortable: true, searchable: true, label:'Aktif'},
        5:{sortable: true, searchable: true, label:'Harga Beli'},
        6:{sortable: false, searchable: false, label:''},
      }
    }
  },
  methods:{
    async deleteRow(payload){
      try {
        await this.$store.dispatch('itempackages/destroy',payload)
        this.$refs.datatables.refresh()
        this.toastSuccess("OK","Data Berhasil Dihapus!")
      } catch (error) {
        this.handleError(error)
      }
    }
  }
}
</script>

<style>

</style>